import { useState, useEffect } from 'react'
import { apiFetch } from '../lib/api'

interface Booking {
  id: string
  hotel_name: string
  check_in: string
  check_out: string
  rate: number
  status: string
  created_at: string
}

export function History() {
  const [bookings, setBookings] = useState<Booking[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchHistory()
  }, [])

  async function fetchHistory() {
    try {
      const data = await apiFetch('/api/worker/history')
      setBookings(data.bookings || [])
    } catch {}
    setLoading(false)
  }

  if (loading) return <div className="page"><p>Loading history...</p></div>

  return (
    <div className="page history">
      <header className="header">
        <h1>History</h1>
        <p>Your past stays</p>
      </header>

      {bookings.length === 0 ? (
        <div className="empty-state">
          <p>No stays yet.</p>
          <p>Get a code and book your first hotel.</p>
        </div>
      ) : (
        <div className="booking-list">
          {bookings.map(booking => (
            <div key={booking.id} className="booking-card">
              <div className="booking-info">
                <h3>{booking.hotel_name || 'Partner Hotel'}</h3>
                <p>{booking.check_in} → {booking.check_out}</p>
              </div>
              <div className="booking-rate">
                <span className="rate">£{booking.rate}</span>
                <span className={`status ${booking.status}`}>{booking.status}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
